import { CoolSwitch } from '@coolremote/shared';
import React from 'react';
import useStyles from './SwitchField.style';
import clsx from 'clsx';

const SwitchField = ({ label, optionOnText, optionOffText, onChange, checked, name }) => {

  const classes = useStyles();

  const handleChange = (event) => {
    onChange(event.target.checked);
  };

  return (
    <div className={classes.switchFieldContainer}>
      <div className={classes.switchFieldLabel}>{label}</div>
      <div className={classes.switchOptionsContainer}>
        <div className={clsx(classes.switchOptionText, classes.optionOff)}>{optionOffText}</div>
        <CoolSwitch
          onChange={handleChange}
          checked={checked}
          name={name}
        />
        <div className={clsx(classes.switchOptionText, classes.optionOn)}>{optionOnText}</div>
      </div>
    </div>
  );
};

export default SwitchField;
